import baseRoute from '../baseRoute';

export default `${baseRoute}/vendor` as const;
